import initValidation from './validation';

const initLocale = () => {
  initValidation();
};

export default initLocale;
